export const PRE_QUALIFIER_VERSION = 'R1'
